import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { http } from "../../services/apiService/apiService";
import * as a from "../../apis/store/actions";
import ReactPaginate from "react-paginate";
import LoadingSpinner from "../../components/loader/loader";
import CountryDisciplines from "../../components/card/country_disciplines_card";
import CountryUniversitiesRankings from "../ranking/country-unis-rankings";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import InstituteCard from "../../components/card/institute_card";
import { useHistory } from "react-router-dom";
import $ from "jquery";
import { getQueryString } from "../../common/getQueryString";
import ErrorPage from "../Error/404";

var _ = require("lodash");

var settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
};

function Country(props) {
  const history = useHistory();
  const {
    match: { params },
  } = props;
  const [instituteType, setInstituteType] = useState([]);
  const [order, setOrder] = useState(null);
  const param = {
    institute_type: instituteType,
    order: order,
  };
  const [pageState, setPageState] = useState({
    offset: 0,
    perPage: 27,
    currentPage: 1,
    pageCount: 0,
  });

  const dispatch = useDispatch();

  const disciplinesList = useSelector(
    ({ apis }) => apis.countryAllDisciplines.data
  );
  const country = useSelector(({ apis }) => apis.countryDetail.data);
  const countryInstitutes = useSelector(
    ({ apis }) => apis.allInstitutesByCountry.data
  );
  const countryFAQs = useSelector(({ apis }) => apis.allFAQsByCountry.data);
  const [readMoreStatus, setReadMoreStatus] = useState(false);
  const [tabStatus, setTabStatus] = useState(false);
  const [faqsList, setFAQsList] = useState(countryFAQs);
  const [showLoader, setShowLoader] = useState(true);
  const [showCountryLoader, setShowCountryLoader] = useState(true);
  const [disciplineLoader, setDisciplineLoader] = useState(true);
  const [countryDetail, setCountryDetail] = useState(country);
  const [disciplines, setDisciplines] = useState([]);
  const [instValue, setInstValue] = useState("");
  const [institutes, setInstitutes] = useState(countryInstitutes?.results);
  const[error,setError]=useState(false);
  useEffect(() => {
    scrollUpToTop();
    setShowCountryLoader(true);
    setDisciplineLoader(true);
    setShowLoader(true);
    if (history.action) {
      dispatch(a.getCountryAllDisciplines(params.countryId)).then((res) => {
        if (res.payload) {
          setDisciplineLoader(false);
        }
        if(res.type==="GET_COUNTRY_ALL_DISCIPLINES_FAIL"){
            setError(true)
        }
      });
      scrollUpToTop();
      dispatch(a.getCountryDetail(params.countryId)).then((response) => {
        if (response.payload.id) {
          setShowCountryLoader(false);
        }
      });
      dispatch(a.getCountryInstitutes(params.countryId, null, null)).then(
        (response) => {
          if (response.payload) {
            setShowLoader(false);
          }
        }
      );
      dispatch(a.getCountryFAQs(params.countryId));
    }
    // if (order || instituteType) {
    //     dispatch(a.getCountryInstitutes(parseInt(params.countryId), null, param));
    // }
  }, [props]);

  function scrollUpToTop() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }

  useEffect(() => {
    if (country) {
      setCountryDetail(country);
    }
    if (disciplinesList) {
      setDisciplines(disciplinesList);
    }
    if (countryInstitutes?.results) {
      setInstitutes(countryInstitutes.results);
      pageState.pageCount = Math.ceil(
        countryInstitutes.count / pageState.perPage
      );
      setPageState(pageState);
    }
    if (countryFAQs) {
      setFAQsList(countryFAQs);
    }
  }, [countryInstitutes, country, disciplinesList]);

  function handlePageClick(e) {
    scrollUp();
    setShowLoader(true);
    let selectedPage = e.selected;
    const offset = selectedPage * pageState.perPage;
    pageState.currentPage = selectedPage;
    pageState.offset = offset;
    setPageState(pageState);
    selectedPage = selectedPage + 1;
    dispatch(a.getCountryInstitutes(params.countryId, selectedPage, param));
    setShowLoader(false);
  }

  function scrollUp() {
    let ViewDiv = document.getElementById("countryView");
    if (ViewDiv) {
      window.scrollTo(0, ViewDiv.offsetTop);
    }
  }

  function readMore() {
    if (readMoreStatus) {
      setReadMoreStatus(false);
    } else {
      setReadMoreStatus(true);
    }
  }

  const viewAllCourse = (e) => {
    let obj = {
      page: "country",
      country: [countryDetail.slug],
    };
    history.push({
      pathname: "/university-course",
      search: getQueryString(obj),
    });
  };
  const countryTabStatus = (id) => {
    if (id === 0) {
      setTabStatus(true);
    } else {
      setTabStatus(false);
    }

    localStorage.setItem("country_tab_status", id);
  };
  const [sortByStatusUni, setSortByStatusUni] = useState(false);
  const [sortByStatusCol, setSortByStatusCol] = useState(false);
  const [sortByStatusPop, setSortByStatusPop] = useState(false);
  const [sortByStatusRev, setSortByStatusRev] = useState(false);
  let paramsFor = {
    institute_type: [],
    order: 0,
  };
  const handleSortBy = (id) => {
    setInstValue("");
    // let ViewDiv = document.getElementById("countrySrtbyView");
    // if (ViewDiv) {
    //     window.scrollTo(0, ViewDiv.offsetTop);
    // }
    if (id === "UNIVERSITY") {
      setSortByStatusPop(false);
      setSortByStatusRev(false);
      setSortByStatusCol(false);
      setInstituteType([id]);
      setSortByStatusUni(true);
      if (sortByStatusUni) {
        setSortByStatusUni(false);
        setOrder(2);
        paramsFor = {
          institute_type: [id],
          order: 2,
        };
      } else {
        setOrder(1);
        paramsFor = {
          institute_type: [id],
          order: 1,
        };
      }
    } else if (id === "COLLEGE") {
      setInstituteType([id]);
      setSortByStatusUni(false);
      setSortByStatusPop(false);
      setSortByStatusRev(false);
      setSortByStatusCol(true);
      if (sortByStatusCol) {
        setSortByStatusCol(false);

        setOrder(2);
        paramsFor = {
          institute_type: [id],
          order: 2,
        };
      } else {
        setOrder(1);
        paramsFor = {
          institute_type: [id],
          order: 1,
        };
      }
    } else if (id === "POPULARITY") {
      setInstituteType([]);
      setSortByStatusUni(false);
      setSortByStatusRev(false);
      setSortByStatusCol(false);
      setSortByStatusPop(true);
      if (sortByStatusPop) {
        setSortByStatusPop(false);
        setOrder(4);
        paramsFor = {
          // institute_type: [id],
          order: 4,
        };
      } else {
        setOrder(3);
        paramsFor = {
          // institute_type: [id],
          order: 3,
        };
      }
    } else if (id === "REVIEW") {
      setInstituteType([]);
      setSortByStatusUni(false);
      setSortByStatusPop(false);
      setSortByStatusCol(false);
      setSortByStatusRev(true);
      if (sortByStatusRev) {
        setSortByStatusRev(false);
        setOrder(6);
        paramsFor = {
          // institute_type: [id],
          order: 6,
        };
      } else {
        setOrder(5);
        paramsFor = {
          // institute_type: [id],
          order: 5,
        };
      }
    }
    setShowLoader(true);
    dispatch(a.getCountryInstitutes(countryDetail.id, null, paramsFor)).then(
      (res) => {
        if (res.payload) {
          setShowLoader(false);
        }
      }
    );
  };

  const handleSearchChange = (value) => {
    setInstValue(value);
    let parm = {};
    parm.name = value;
    if (value.length === 0) {
      setInstitutes(countryInstitutes.results);
      setSortByStatusUni(false);
      setSortByStatusPop(false);
      setSortByStatusCol(false);
      setSortByStatusRev(false);
    }
  };

  async function getInstitute() {
    let parm = {};
    setSortByStatusUni(false);
    setSortByStatusPop(false);
    setSortByStatusCol(false);
    setSortByStatusRev(false);
    parm.name = instValue;
    if (instValue.length > 0) {
      await http
        .get(`country/${countryDetail.slug}/institutes_suggestion/`, parm)
        .then((response) => {
          setInstitutes(response.data);
        });
    } else {
      setInstitutes(countryInstitutes.results);
    }
  }
  if(error) {
    return <ErrorPage />
}

  return (
    <>
      {showCountryLoader ? (
        <LoadingSpinner />
      ) : (
        <div className="main">
          <div className="countryBanner">
            <img
              src={require("../../../static/images/country-banner.svg").default}
              alt="banner"
            />
            <div className="content">
              <h1>Explore thousands of programs across the world.</h1>
            </div>
          </div>
          <div className="disciplineInfoBanner">
            <div className="container" id={"countryView"}>
              <div className="countryInfoFlex">
                {Object.keys(countryDetail).length > 0 ? (
                  <div className="left">
                    <h3>Study in {countryDetail?.name}</h3>
                    {readMoreStatus ? (
                      <div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: countryDetail?.description,
                          }}
                        ></div>
                        <button className="btn" onClick={readMore}>
                          Read Less
                        </button>
                      </div>
                    ) : (
                      <div>
                        <p>{countryDetail.short_description}</p>
                        <button className="btn" onClick={readMore}>
                          Read More
                        </button>
                      </div>
                    )}{" "}
                  </div>
                ) : (
                  <LoadingSpinner />
                )}
                <div className="right">
                  <img src={countryDetail.logo} alt="banner" />
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <Tabs className="customTabs countryPageTabs" defaultIndex={1}>
              <TabList>
                <Tab onClick={() => countryTabStatus(0)}>
                  Institutes in {countryDetail.name}
                </Tab>
                <Tab onClick={() => countryTabStatus(1)}>
                  Programs in {countryDetail.name}
                </Tab>
              </TabList>

              <TabPanel>
                <div className="countrySearchWrap">
                  <input
                    type="text"
                    value={instValue}
                    placeholder="Type here"
                    className="form-control"
                    onChange={(e) => handleSearchChange(e.target.value)}
                  />
                  <button className="btn" onClick={(e) => getInstitute(e)}>
                    Search
                  </button>
                  <i className={"fa fa-search"} />
                </div>
                <div id="countrySrtbyView" className="countrySort">
                  <p>Sort by:</p>
                  <button
                    className={sortByStatusUni ? "btn active" : "btn"}
                    id="university"
                    value="UNIVERSITY"
                    onClick={(e) => {
                      handleSortBy(e.target.value);
                    }}
                  >
                    Universities{" "}
                    <img
                      src={
                        require("../../../static/images/asc-sort.svg").default
                      }
                      alt="banner"
                    />
                  </button>
                  <button
                    className={sortByStatusCol ? "btn active" : "btn"}
                    id="college"
                    value="COLLEGE"
                    onClick={(e) => {
                      handleSortBy(e.target.value);
                    }}
                  >
                    Colleges{" "}
                    <img
                      src={
                        require("../../../static/images/asc-sort.svg").default
                      }
                      alt="banner"
                    />
                  </button>
                  <button
                    className={sortByStatusPop ? "btn active" : "btn"}
                    id="popularity"
                    value="POPULARITY"
                    onClick={(e) => {
                      handleSortBy(e.target.value);
                    }}
                  >
                    Popularity{" "}
                    <img
                      src={
                        require("../../../static/images/asc-sort.svg").default
                      }
                      alt="banner"
                    />
                  </button>
                  <button
                    className={sortByStatusRev ? "btn active" : "btn"}
                    id="review"
                    value="REVIEW"
                    onClick={(e) => {
                      handleSortBy(e.target.value);
                    }}
                  >
                    Reviews{" "}
                    <img
                      src={
                        require("../../../static/images/asc-sort.svg").default
                      }
                      alt="banner"
                    />
                  </button>
                </div>
                {showLoader ? (
                  <LoadingSpinner />
                ) : institutes && countryDetail ? (
                  <div key="instituteCard">
                    <InstituteCard data={institutes} country={countryDetail} />
                    {instValue !== "" ? null : (
                      <div className="paginationWrap">
                        <ReactPaginate
                          previousLabel={"Prev"}
                          nextLabel={"Next"}
                          breakLabel={"..."}
                          breakClassName={"break-me"}
                          pageCount={pageState.pageCount}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={handlePageClick}
                          containerClassName={"pagination"}
                          subContainerClassName={"pages pagination"}
                          activeClassName={"active"}
                          nextClassName={"next"}
                          previousClassName={"previous"}
                          disabledClassName={"disabled"}
                        />
                      </div>
                    )}
                  </div>
                ) : (
                  <h4 style={{ textAlign: "center" }}>Record not found</h4>
                )}
              </TabPanel>
              <TabPanel>
                {disciplineLoader ? (
                  <LoadingSpinner />
                ) : disciplines ? (
                  <div key="countryDiscipline">
                    <CountryDisciplines
                      disciplines={disciplines}
                      countryDetail={countryDetail}
                    />
                    <div
                      style={{
                        textAlign: "center",
                        marginBottom: 20,
                      }}
                    >
                      {/* <button
                                                className="btn defaultBtn"
                                                onClick={(e) => viewAllCourse(e)}
                                            >
                                                View all Courses of {countryDetail.name}
                                            </button> */}
                    </div>
                  </div>
                ) : (
                  <h4 style={{ textAlign: "center" }}>Record not found</h4>
                )}
              </TabPanel>
            </Tabs>

            {/* </div> */}
          </div>
          {showCountryLoader ? (
            <LoadingSpinner />
          ) : _.isEmpty(countryDetail) === false ? (
            <CountryUniversitiesRankings
              countryDetail={countryDetail}
              action={history.action}
            />
          ) : (
            "Record not found"
          )}
          <div className={"container"}>
            <div className="countryFaqs">
              <h6>Frequently Asked Questions</h6>
              <div className="accordion">
                {faqsList
                  ? faqsList.map((item, index) =>
                      index > -1 ? (
                        <div className="card" key={index}>
                          <button
                            className="btn"
                            id={"heading" + item.id}
                            type="button"
                            data-toggle="collapse"
                            data-target={"#collapse" + item.id}
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            {item.question}
                            <i className="fa fa-chevron-down"></i>
                          </button>
                          <div
                            id={"collapse" + item.id}
                            className="collapse accordText"
                            aria-labelledby={"heading" + item.id}
                          >
                            <p>{item.answer}</p>
                          </div>
                        </div>
                      ) : null
                    )
                  : null}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Country;
